import clsx from 'clsx';
import { motion, MotionProps } from 'framer-motion';
import { forwardRef } from 'react';

export interface SectionHeaderProps {
  header: string | React.ReactNode;
  /** Set on the wrapper so a section can `aria-labelledby` its header. */
  id?: string;
  className?: string;
  motionProps?: MotionProps;
}

export const SectionHeader = forwardRef<HTMLDivElement, SectionHeaderProps>(
  ({ header, id, className, motionProps }, ref) => {
    return (
      <motion.div
        ref={ref}
        id={id}
        {...motionProps}
        className={clsx('SectionHeader', 'w-auto flex h-auto items-center pt-[13px] pb-4 min-h-12', className)}
      >
        {typeof header === 'string' ? (
          <p
            className={clsx(
              'SectionHeader-Title',
              'text-darkMode-gray-medium tracking-[0.286px] leading-[normal] font-bold text-base'
            )}
          >
            {header}
          </p>
        ) : (
          header
        )}
      </motion.div>
    );
  }
);
